import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useParams } from "react-router-dom";
import useProduct from "../hooks/useProduct";
import { Tab, Row, Col, Nav } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { formatDescription } from "../helpers/functions";
import { URLDefaultLogoTensolite } from "../helpers/constants";

//Texto variable que debe ser sacado una vez que se envíe el objeto con los datos del producto

const InstalacionProductos = () => {
  const [indexStep, setIndexStep] = useState("0");
  const [imgAlphaProduct, setImgAlphaProduct] = useState("");
  const [setWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { getProductsByBody, product } = useProduct();
  const params = useParams();

  useEffect(() => {
    var url = product?.imageProductAlpha?.[0]?.url;
    var image = new Image();
    image.src = url;

    image.addEventListener("load", () => setImgAlphaProduct(url));
    image.addEventListener("error", () => setImgAlphaProduct(""));
  }, [product]);

  useEffect(() => {
    getProductsByBody({ title: params.id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { instalationSteps, imageLogo, imageIcon } = product;

  return (
    <>
      <HelmetProvider>
        <Helmet prioritizeSeoTags>
            <title>{`Instalación de ${product?.title}`}</title>
            <meta name="title" content={`Instalación de ${product?.title}`}/>
          <meta name="description" content={product?.top_mobile && product?.top_mobile?.length > 0 ? product.top_mobile : formatDescription(product?.top) } />

          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content={`https://tensolite.com`}
          />
          <meta property="og:title" content={`Instalación de ${product?.title}`} />
          <meta property="og:description" content={`${product?.top}`} />
          <meta property="og:image" content={`${URLDefaultLogoTensolite}`} />
          
          <meta property="twitter:card" content="summary_large_image" />
          <meta
            property="twitter:url"
            content={`https://tensolite.com`}
          />
          <meta property="twitter:title" content={`Instalación de ${product?.title}`} />
          <meta property="twitter:description" content={`${product?.top}`} />
          <meta property="twitter:image" content={`${URLDefaultLogoTensolite}`} />
        </Helmet>
      </HelmetProvider>
      <div className="bg-fullpage-grey">
        <div className="container install-products">
          {/* Primer Linea del Componente → Flecha+Titulo - Logo - Imagen Producto */}
          <div className="row align-items-center mb-2">
            <div className="col-12 col-lg-8 install-products-components-2">
              <h1 className="title-card-slider">
                <ArrowBackIcon
                  type="button"
                  onClick={() => window.history.back()}
                  fontSize="inherit"
                />
                Instalación
              </h1>
            </div>
            <div className="col-6 col-lg-2">
              <img
                className="instalacion-logo"
                src={product?.imageLogoColor?.[0]?.url}
                alt={product?.imageLogo ? product?.imageLogoColor[0]?.alt : product?.title}
              />
            </div>
            <div className="col-6 col-lg-2 d-flex justify-content-end justify-content-lg-start">
              {imgAlphaProduct && product?.imageProductAlpha?.[0]?.url && (
                <img
                  className="instalacion-logo"
                  id="img_log_testing"
                  src={product?.imageProductAlpha?.[0]?.url}
                  alt={product?.imageProductAlpha?.[0]?.alt}
                />
              )}
            </div>
          </div>
          {/* <StepperInstalation instalationSteps={instalationSteps}/> */}
          <Tab.Container id="steps-instalaciones" defaultActiveKey={0}>
            <Row>
              <Col md={5} lg={4} xl={3} className="sticky-top sidebar_step">
                <Nav variant="pills" className="flex-md-column pb-md-5">
                  {instalationSteps?.map((step, index) => (
                    <Nav.Item className="py-2" key={index}>
                      <Nav.Link
                        className="steps-instalaciones d-md-flex"
                        eventKey={index}
                        onClick={() => setIndexStep(index)}
                      >
                        <span className="button_step me-3">{index + 1}</span>{" "}
                        <span className="name_step">{step?.stepTitle}</span>
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </Col>
              <Col md={7} lg={8} xl={9}>
                <Tab.Content>
                  <Tab.Pane defaultValue={0} eventKey={indexStep ? indexStep : "0"}>
                    <div className="col-12 install-products-components-2">
                      <div className="row align-items-start m-2">
                        {product?.instalationSteps?.[indexStep ? indexStep : "0"]
                          .imageInstallation && (
                          <img
                            className="col-12 col-lg-4 instalacion-product mb-3 mb-lg-5"
                            src={
                              product?.instalationSteps[indexStep ? indexStep : "0"]
                                ?.imageInstallation[0]?.url
                            }
                            alt={
                              product?.instalationSteps[indexStep ? indexStep : "0"]
                                ?.imageInstallation[0]?.alt
                            }
                          />
                        )}
                        <div className="col-12 col-lg-12 col-xl-7">
                          <h3 className="text_mobile_step">
                            {instalationSteps?.[indexStep ? indexStep : "0"]?.stepTitle}
                          </h3>

                          <p
                            className="step_text productInstallationSteps-tiny-editor"
                            dangerouslySetInnerHTML={{
                              __html:
                                instalationSteps?.[indexStep ? indexStep : "0"]?.stepDescription
                            }}
                          ></p>
                        </div>
                      </div>
                      {instalationSteps?.[indexStep ? indexStep : "0"]?.stepWarningText && (
                        <div className="col-12 col-lg-12 install-products-components-2 m-auto">
                          <div className="row advertise_step align-items-center mt-2">
                            <div className="col-12 col-sm-4 text-center mt-2">
                              <p>
                                <WarningAmberIcon fontSize="large" className="icon-advertise2" />
                              </p>
                            </div>
                            <div className="col-12 col-sm-8 mt-2">
                              <p>
                                {instalationSteps?.[indexStep ? indexStep : "0"]?.stepWarningText}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </div>
    </>
  );
};

export default InstalacionProductos;
